var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var NewFileFilled = function (_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V11.1L12 19.075V22H6ZM14 22V19.875L19.15 14.7L21.3 16.8L16.125 22H14ZM22.025 16.1L19.9 13.975L20.6 13.275C20.8 13.075 21.0417 12.975 21.325 12.975C21.6083 12.975 21.8417 13.075 22.025 13.275L22.725 14C22.9083 14.2 23 14.4375 23 14.7125C23 14.9875 22.9083 15.2167 22.725 15.4L22.025 16.1ZM13 9H18L13 4V9Z", fill: color }) })));
};
